import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Offers from '../../components/Admin/Offers/Offers';

const AdminOffers = () => {
  const { setIsLoading } = useOutletContext();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
          Gestion des offres
        </h1>
        <p className="text-slate-600 dark:text-slate-400 mt-2">
          Gérez toutes les offres publiées sur la plateforme
        </p>
      </div>
      
      <Offers setIsLoading={setIsLoading} />
    </div>
  );
};

export default AdminOffers; 